<section class="auction-bid-panel">
  <pwj-auction-countdown-timer
    [finishDate]="auction()?.finish_date"
    [startDate]="auction()?.start_date"></pwj-auction-countdown-timer>

  <div class="auction-bid-panel__sheet">
    <div class="auction-bid-panel__tabs-wrap">
      <ul class="auction-bid-panel__tabs">
        @for (tab of tabs; track tab.tabTitle) {
          <li
            class="auction-bid-panel__tab"
            [class.auction-bid-panel__tab--active]="activeTab() === tab.tabTitle"
            (click)="onSelectTab(tab.tabTitle)">
            {{ getTabLabel(tab.tabTitle) | translate }}
            @if (tab.tabTitle === 'bids-live' && bidsCount() > 0) {
              <span class="auction-bid-panel__tab-count">({{ bidsCount() }})</span>
            }
          </li>
        }
      </ul>
    </div>

    <div class="auction-bid-panel__content">
      @switch (activeTab()) {
        @case ('place-bid') {
          <div class="auction-bid-panel__prices">
            <div class="auction-bid-panel__price-card auction-bid-panel__price-card--base">
              <p class="auction-bid-panel__price-label">
                {{ 'auctions.auctionBasePrice' | translate }}
              </p>
              <p class="auction-bid-panel__price-strike">
                {{ currencyToSymbol(auction()?.currency) }}
                {{ auction()?.base_price | number }}
              </p>
              <p class="auction-bid-panel__price-note">
                {{ 'auctions.floorStandard' | translate }}
              </p>
            </div>

            <div class="auction-bid-panel__price-card auction-bid-panel__price-card--high">
              <p class="auction-bid-panel__price-label auction-bid-panel__price-label--high">
                {{ 'auctions.currentHighBid' | translate }}
              </p>
              <p class="auction-bid-panel__price-current">
                {{ currencyToSymbol(auction()?.currency) }}
                {{ currentHighBid | number }}
              </p>
              <p class="auction-bid-panel__price-note auction-bid-panel__price-note--high">
                <i class="iconsax" icon-name="arrow-up-2"></i>
                {{ 'auctions.highestBidderLeads' | translate }}
              </p>
            </div>
          </div>

          @if (isUserLoggedIn) {
            <form class="auction-bid-panel__form" [formGroup]="bidForm" (submit)="submitBid()">
              <label class="auction-bid-panel__field-label">
                {{ 'auctions.enterCustomBid' | translate }}
              </label>
              <div class="auction-bid-panel__input-wrap">
                <span class="auction-bid-panel__input-prefix">{{
                  currencyToSymbol(auction()?.currency)
                }}</span>
                <input
                  class="auction-bid-panel__input"
                  type="number"
                  formControlName="bidAmount"
                  [placeholder]="minimumBid.toString()" />
                <span class="auction-bid-panel__input-suffix">{{
                  auction()?.currency | uppercase
                }}</span>
              </div>

              <p class="auction-bid-panel__field-label">
                {{ 'auctions.quickAddIncrements' | translate }}
              </p>

              @if (confirmedProcess()) {
                <p class="auction-bid-panel__confirm-msg">
                  <i
                    class="iconsax auction-bid-panel__confirm-icon"
                    icon-name="warning-triangle"></i>
                  {{ 'auctions.bidConfirmationQuestion' | translate }}
                  <span class="auction-bid-panel__confirm-warning">
                    {{ 'auctions.bidConfirmationWarning' | translate }}
                  </span>
                </p>
              }

              <div class="auction-bid-panel__actions-row">
                <div class="auction-bid-panel__increments">
                  @for (increment of quickIncrements; track increment) {
                    <button
                      type="button"
                      class="auction-bid-panel__increment-btn"
                      (click)="applyQuickIncrement(increment)">
                      +{{ currencyToSymbol(auction()?.currency) }}{{ increment | number }}
                    </button>
                  }
                </div>

                <pwj-button
                  class="auction-bid-panel__submit"
                  variant="primary"
                  size="large"
                  icon="chevron-right"
                  [rotateIconInRtl]="true"
                  [iconReversePosition]="true"
                  type="submit"
                  matomoClickCategory="Auction"
                  matomoClickAction="Bid"
                  matomoClickName="Auction Details"
                  [disabled]="
                    !isActive() ||
                    !hasAccessToCreateBid ||
                    bidForm.invalid ||
                    isDisabledSubmitBtn() ||
                    formIsSubmitting()
                  ">
                  {{ 'auctions.participateSubmitBid' | translate }}
                </pwj-button>
              </div>
            </form>
          } @else {
            <div class="auction-bid-panel__action">
              <div class="auction-bid-panel__cta">
                <pwj-button
                  variant="primary"
                  size="large"
                  icon="chevron-right"
                  [rotateIconInRtl]="true"
                  [iconReversePosition]="true"
                  type="button"
                  matomoClickCategory="Authentication"
                  matomoClickAction="Login"
                  matomoClickName="Auction"
                  (click)="openLoginDialog()">
                  {{ 'auctions.participateSubmitBid' | translate }}
                </pwj-button>
              </div>

              <p class="auction-bid-panel__escrow">
                <i
                  class="iconsax auction-bid-panel__escrow-icon"
                  icon-name="shield-tick"></i>
                {{ 'auctions.bidProtected' | translate }}
              </p>
              <p class="auction-bid-panel__legal-links">
                {{ 'auctions.byBidding' | translate }}
                <a routerLink="/legal/payment-terms" class="auction-bid-panel__legal-link" target="_blank">
                  {{ 'auctions.paymentTermsLink' | translate }}</a>.
              </p>
            </div>
          }

          @if (isUserLoggedIn) {
            <p class="auction-bid-panel__escrow">
              <i class="iconsax auction-bid-panel__escrow-icon" icon-name="shield-tick"></i>
              {{ 'auctions.bidProtected' | translate }}
            </p>
            <p class="auction-bid-panel__legal-links">
              {{ 'auctions.byBidding' | translate }}
              <a routerLink="/legal/payment-terms" class="auction-bid-panel__legal-link" target="_blank">
                {{ 'auctions.paymentTermsLink' | translate }}</a>.
            </p>
          }
        }

        @case ('lot-specs') {
          <pwj-auction-lot-specs-tab [auction]="auction()"></pwj-auction-lot-specs-tab>
        }

        @case ('bids-live') {
          <pwj-auction-bids-live-tab [auction]="auction()"></pwj-auction-bids-live-tab>
        }
      }
    </div>
  </div>
</section>
